var exports = {
  "i": "LiveBadge.module__liveBadge___OGlwNW",
  "f": "LiveBadge.module__liveBadgeOnVoiceTile___OGlwNW",
};

module.exports = exports;
